import React, { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Switch */
import Switch from "react-switch"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { update } from "../../api/Bonus"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Icons */
import { CloseIcon, JackpotIcon, SafeIcon, EyeIcon, PlayerIcon } from "./BonusIcons"

/* Utils */
import { formatAmount, parseAmount, toNumber } from "./BonusUtils"


/* Widget Jackpot Update */
class JackpotUpdate extends Component {

    constructor(props) {
        super(props)

        /* Fields */
        const { data } = this.props

        this.state = {
            jackpot: formatAmount(data && data.jackpot ? Number(data.jackpot).toFixed(2) : "0"),
            score: formatAmount(data && data.score ? Number(data.score).toFixed(2) : "0"),
            enabled: Boolean(data && parseInt(data.enabled) === 1),
            testersOnly: Boolean(data && parseInt(data.testersOnly) === 1),
            waiting: false,
        }
    }

    /* Short Sign Of An Operator */
    getSign = (name) => {

        /* Check Name */
        if (!name || String(name).trim() === "") {
            return "?"
        }

        /* Send Result */
        return String(name).trim().charAt(0).toUpperCase()
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { jackpot, score, enabled, testersOnly } = this.state
        const { socket, data } = this.props

        /* Fields — пул строки: 1 живые игры, 0 электронные */
        const operatorID = data && data.id ? data.id : 0
        const live = data && parseInt(data.live) === 1 ? 1 : 0

        /* Check Operator */
        if (operatorID === 0) {
            Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            return
        }

        /* Fields */
        const jackpotTotal = parseAmount(jackpot)
        const scoreTotal = parseAmount(score)

        /* Waiting */
        this.setState({ waiting: true })

        /* Update */
        update({ operatorID, live, jackpot: jackpotTotal, score: scoreTotal, enabled: enabled ? 1 : 0, testersOnly: testersOnly ? 1 : 0 }).then((response) => {
            if (response.status === 200) {
                socket.emit("jackpotUpdate", { operatorID, live, jackpot: jackpotTotal })
                Swal.fire(utils.notification(t("swal.savedSuccess"), "success"))
            }
            else {
                Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* Draw One Amount — the value kept in the database is shown under the input while it is changed */
    _field = (icon, label, value, before, key) => {

        /* Fields */
        const changed = parseAmount(value) !== toNumber(before)

        return (
            <div className="bns--field">

                <div className="bns--field-label">
                    {icon}
                    {label}
                </div>

                <div className="bns--field-input">
                    <span className="bns--field-sign">$</span>
                    <input
                        value={value}
                        onChange={(event) => this.setState({ [key]: formatAmount(event.target.value) })}
                        inputMode="decimal"
                        placeholder="0"
                    />
                </div>

                {changed &&
                    <div className="bns--field-note">{t("bns.wasAmount")} {utils.convertor(before, "USD", 1)}</div>
                }

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, close, data } = this.props
        const { jackpot, score, enabled, testersOnly, waiting } = this.state

        /* Пул строки — для какого типа игр этот джекпот */
        const live = data && parseInt(data.live) === 1

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => close()}
                className="bns--modal small"
                overlayClassName="bns--overlay"
                closeTimeoutMS={200}
            >

                <div className="bns--modal-header">

                    <div className="bns--jp-sign big">{this.getSign(data ? data.name : "")}</div>

                    <div className="bns--modal-head-text">
                        <h2>{data ? utils.checkValue(data.name, "—") : "—"}</h2>
                        <p>{t("bns.updateSubtitle")}</p>
                        <div className={`bns--jp-pool ${live ? "live" : "electron"}`}>{live ? t("bns.poolLive") : t("bns.poolElectron")}</div>
                    </div>

                    <div onClick={() => close()} className="bns--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="bns--modal-body">

                    <div className="bns--fields">
                        {this._field(<JackpotIcon size={12} />, "JACKPOT", jackpot, data ? data.jackpot : 0, "jackpot")}
                        {this._field(<SafeIcon size={12} />, t("bns.cash"), score, data ? data.score : 0, "score")}
                    </div>

                    <div className={`bns--toggle ${enabled ? "active" : ""}`}>

                        <div className="bns--toggle-icon">
                            <EyeIcon size={15} />
                        </div>

                        <div className="bns--toggle-text">
                            <div className="bns--toggle-title">{t("bns.visibility")}</div>
                            <div className="bns--toggle-note">{enabled ? t("bns.visibilityOn") : t("bns.visibilityOff")}</div>
                        </div>

                        <Switch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor="#66bb6a"
                            height={22}
                            width={44}
                            handleDiameter={16}
                            onChange={(value) => this.setState({ enabled: value })}
                            checked={enabled}
                        />

                    </div>

                    {/* Обкатка пула — ставку делают только тестовые аккаунты */}
                    <div className={`bns--toggle ${testersOnly ? "active" : ""}`}>

                        <div className="bns--toggle-icon">
                            <PlayerIcon size={15} />
                        </div>

                        <div className="bns--toggle-text">
                            <div className="bns--toggle-title">{t("bns.testersOnly")}</div>
                            <div className="bns--toggle-note">{testersOnly ? t("bns.testersOnlyOn") : t("bns.testersOnlyOff")}</div>
                        </div>

                        <Switch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor="#ffa726"
                            height={22}
                            width={44}
                            handleDiameter={16}
                            onChange={(value) => this.setState({ testersOnly: value })}
                            checked={testersOnly}
                        />

                    </div>

                </div>

                <div className="bns--modal-footer">

                    <div className="bns--modal-footer-right">
                        <div onClick={() => close()} className="bns--button ghost">{t("common.cancel")}</div>
                        <div onClick={() => !waiting && this.save()} className={`bns--button primary ${waiting ? "waiting" : ""}`}>
                            {waiting ? <LoadingOutlined /> : t("common.save")}
                        </div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(JackpotUpdate)
